const genomes = {
  nuclear: {
    hg19: [
      { id: 1, key: "1", size: 249250621 },
      { id: 2, key: "2", size: 243199373 },
      { id: 3, key: "3", size: 198022430 },
      { id: 4, key: "4", size: 191154276 },
      { id: 5, key: "5", size: 180915260 },
      { id: 6, key: "6", size: 171115067 },
      { id: 7, key: "7", size: 159138663 },
      { id: 8, key: "8", size: 146364022 },
      { id: 9, key: "9", size: 141213431 },
      { id: 10, key: "10", size: 135534747 },
      { id: 11, key: "11", size: 135006516 },
      { id: 12, key: "12", size: 133851895 },
      { id: 13, key: "13", size: 115169878 },
      { id: 14, key: "14", size: 107349540 },
      { id: 15, key: "15", size: 102531392 },
      { id: 16, key: "16", size: 90354753 },
      { id: 17, key: "17", size: 81195210 },
      { id: 18, key: "18", size: 78077248 },
      { id: 19, key: "19", size: 59128983 },
      { id: 20, key: "20", size: 63025520 },
      { id: 21, key: "21", size: 48129895 },
      { id: 22, key: "22", size: 51304566 },
      { id: 23, key: "x", size: 155270560 },
      { id: 24, key: "y", size: 59373566 },
    ],
    hg38: [
      { id: 1, key: "1", size: 248956422 },
      { id: 2, key: "2", size: 242193529 },
      { id: 3, key: "3", size: 198295559 },
      { id: 4, key: "4", size: 190214555 },
      { id: 5, key: "5", size: 181538259 },
      { id: 6, key: "6", size: 170805979 },
      { id: 7, key: "7", size: 159345973 },
      { id: 8, key: "8", size: 145138636 },
      { id: 9, key: "9", size: 138394717 },
      { id: 10, key: "10", size: 133797422 },
      { id: 11, key: "11", size: 135086622 },
      { id: 12, key: "12", size: 133275309 },
      { id: 13, key: "13", size: 114364328 },
      { id: 14, key: "14", size: 107043718 },
      { id: 15, key: "15", size: 101991189 },
      { id: 16, key: "16", size: 90338345 },
      { id: 17, key: "17", size: 83257441 },
      { id: 18, key: "18", size: 80373285 },
      { id: 19, key: "19", size: 58617616 },
      { id: 20, key: "20", size: 64444167 },
      { id: 21, key: "21", size: 46709983 },
      { id: 22, key: "22", size: 50818468 },
      { id: 23, key: "x", size: 156040895 },
      { id: 24, key: "y", size: 57227415 },
    ],
  },
  mito: {
    hg19: {
      m: [{ id: 0, key: "m", size: 16571 }],
      mt: [{ id: 93, key: "mt", size: 16569 }],
    },
    hg38: {
      m: [{ id: 0, key: "m", size: 16569 }],
      mt: [{ id: 0, key: "mt", size: 16569 }],
    },
  },
};

export default genomes;
